// @ts-nocheck
/* eslint-disable react-refresh/only-export-components */
import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { normalizeLanguageCode } from '../../lib/i18n'
import { appLanguageByLocale, type SeoLocale } from '../../lib/public-seo'
import { GlobalStyle } from './public-data'

const PublicContext = createContext(null)

export function PublicProvider({ children, locale = 'en' }: { children: React.ReactNode; locale?: SeoLocale }) {
  const [lang, setLangRaw] = useState(() => {
    try {
      const stored = localStorage.getItem('bbg-language')
      const cookie = document.cookie.match(/(?:^|; )bbg-language=([^;]+)/)?.[1]
      return normalizeLanguageCode(appLanguageByLocale[locale] || stored || cookie || 'EN')
    } catch {
      return normalizeLanguageCode(appLanguageByLocale[locale] || 'EN')
    }
  })
  const [contactOpen, setContactOpen] = useState(false)
  const [languageOpen, setLanguageOpen] = useState(false)
  const [helpCenterOpen, setHelpCenterOpen] = useState(false)

  const setLang = useCallback((code) => setLangRaw(normalizeLanguageCode(code)), [])
  const navigate = useCallback((path, options) => {
    if (options?.replace) window.history.replaceState({}, '', path)
    else window.history.pushState({}, '', path)
    window.dispatchEvent(new PopStateEvent('popstate'))
  }, [])
  const value = useMemo(() => ({
    lang,
    locale,
    setLang,
    navigate,
    contactOpen,
    setContactOpen,
    languageOpen,
    setLanguageOpen,
    helpCenterOpen,
    setHelpCenterOpen,
  }), [lang, locale, setLang, navigate, contactOpen, languageOpen, helpCenterOpen])

  return (
    <PublicContext.Provider value={value}>
      <GlobalStyle />
      {children}
    </PublicContext.Provider>
  )
}

export function usePublicApp() {
  const ctx = useContext(PublicContext)
  if (!ctx) throw new Error('usePublicApp must be used within PublicProvider')
  return ctx
}
